import { Button, IconButton, LinearProgress, Box, Typography, Avatar, Badge, Stack } from '@mui/material'
import { styled } from '@mui/material/styles';
import { useEffect, useState, useRef } from 'react'
import axios from "axios"
import { ArrowBack } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import { Close, Share, Download, Mic, Stop, Pause, PlayArrow, Image, Videocam, InsertDriveFile, AccountCircle } from '@mui/icons-material';
import SendIcon from '@mui/icons-material/Send';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import AudioWave from './AudioWave'
import Lottie from 'lottie-react'
import typinganimation from '../Assets/animations/typinganimation.json'
import { teleConsultationModel } from '../Axios/AxiosConfig'
import { useNavigate } from 'react-router-dom';

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));

const LinkPreviewCard = ({ url }) => {
    const [metadata, setMetadata] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMetadata = async () => {
            try {
                const response = await axios.get(`https://api.microlink.io/?url=${encodeURIComponent(url)}`);
                if (response.data && response.data.status === 'success') {
                    setMetadata(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching link metadata:', error);
            } finally {
                setLoading(false);
            }
        };

        if (url) {
            fetchMetadata();
        }
    }, [url]);

    if (loading) {
        return (
            <div style={{
                padding: '10px',
                borderRadius: '8px',
                backgroundColor: '#f0f0f0',
                margin: '8px 0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                <div style={{ width: '40px', height: '40px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
                <div style={{ flex: 1 }}>
                    <div style={{ width: '60%', height: '10px', backgroundColor: '#e0e0e0', marginBottom: '5px' }}></div>
                    <div style={{ width: '40%', height: '8px', backgroundColor: '#e0e0e0' }}></div>
                </div>
            </div>
        );
    }

    if (!metadata) return null;

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                textDecoration: 'none',
                display: 'block',
                margin: '8px 0',
                borderRadius: '12px',
                overflow: 'hidden',
                border: '1px solid #e0e0e0',
                backgroundColor: 'white',
                boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
                transition: 'transform 0.2s ease',
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
            {metadata.image && (
                <div style={{ width: '100%', height: '140px', overflow: 'hidden' }}>
                    <img
                        src={metadata.image.url}
                        alt={metadata.title}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                </div>
            )}
            <div style={{ padding: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    {metadata.logo && (
                        <img
                            src={metadata.logo.url}
                            alt="logo"
                            style={{ width: '16px', height: '16px', borderRadius: '2px' }}
                        />
                    )}
                    <span style={{
                        fontSize: '12px',
                        color: '#666',
                        fontWeight: '500',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>
                        {metadata.publisher || new URL(url).hostname}
                    </span>
                </div>
                <div style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#333',
                    marginBottom: '4px',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                }}>
                    {metadata.title}
                </div>
                {metadata.description && (
                    <div style={{
                        fontSize: '12px',
                        color: '#666',
                        lineHeight: '1.4',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                    }}>
                        {metadata.description}
                    </div>
                )}
            </div>
        </a>
    );
};

function Chat({ currentChat, online: onlineProp = [], lastseen: lastseenProp = [], fromProfile = false }) {

    const navigate = useNavigate();

    let [msg, setmsg] = useState('');

    const textAreaRef = useRef(null);

    let { patient_id, doctor_uid, doctor_id, Appointment_id } = currentChat

    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const [open, setOpen] = useState(false);

    const fileInputRef = useRef(null);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFileSelection = (type) => {
        if (type === "image") {
            fileInputRef.current.accept = "image/*";
        } else if (type === "video") {
            fileInputRef.current.accept = "video/*";
        } else {
            fileInputRef.current.accept = ".pdf,.doc,.docx,.xls,.xlsx,.txt";
        }
        fileInputRef.current.click();
        handleClose();
    };

    // Handle file selection
    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Determine file type
        let type = "document";
        if (file.type.startsWith("image/")) type = "image";
        else if (file.type.startsWith("video/")) type = "video";

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = async () => {
            const base64File = reader.result.split(',')[1];
            try {
                setIsUploading(true);
                setUploadProgress(0);

                const response = await teleConsultationModel.post('UploadChatImage', {
                    file: base64File,
                    appointment_ID: Appointment_id,
                    filename: file.name
                }, {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    }
                });

                if (response.data && response.data.data) {
                    sendJsonMessage({
                        action: "sendMessage",
                        message: response.data.data,
                        type: type,
                        from: doctor_id,
                        to: patient_id,
                        conversationId: `${currentChat?.Appointment_id}`,
                        filename: file.name // Store filename for documents
                    });

                    // Optional: sendChatNotification(doctor_id, patient_id, type, response.data.data);
                }
            } catch (error) {
                console.error('Error uploading file:', error);
                alert('Failed to upload file. Please try again.');
            } finally {
                setIsUploading(false);
                setUploadProgress(0);
            }
        };
    };

    const [online, setOnline] = useState(onlineProp);
    const [lastseen, setLastSeen] = useState(lastseenProp);

    useEffect(() => {
        setOnline(onlineProp);
    }, [onlineProp]);

    useEffect(() => {
        setLastSeen(lastseenProp);
    }, [lastseenProp]);

    let [messages, setmessages] = useState([])

    const WS_URL =
        `wss://a7uoyq8x2j.execute-api.ap-south-1.amazonaws.com/production/` +
        `?userId=${doctor_id}&appointmentId=${Appointment_id}&role=doctor`;

    const { sendJsonMessage, lastJsonMessage, readyState } =
        useWebSocket(WS_URL, {
            onOpen: () => {
                console.log("WebSocket connection established.");
            },
            share: false,
            shouldReconnect: () => true,
        });

    useEffect(() => {
        if (readyState === ReadyState.OPEN) {
            sendJsonMessage({
                event: "subscribe",
                data: {
                    channel: "general-chatroom",
                },
            });
            getChatUser();
        }
    }, [readyState]);

    let [arrivalMessage, setArrivalMessage] = useState(null);

    let scrollRef = useRef();
    const messagesEndRef = useRef(null);
    const typingTimeoutRef = useRef(null);
    const [isPatientTyping, setIsPatientTyping] = useState(false);
    const [mediaDialog, setMediaDialog] = useState({ open: false, media: null, type: null, date: null });

    // Audio recording states
    const [isRecording, setIsRecording] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [recordingTime, setRecordingTime] = useState(0);
    const [showRecordingModal, setShowRecordingModal] = useState(false);

    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const recordingIntervalRef = useRef(null);

    const sendIconStyle = {
        width: '44px',
        height: '44px',
        minWidth: '44px',
        display: 'flex',
        padding: '0',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#da6e0b',
        color: 'white',
        borderRadius: '50%',
        boxShadow: '0 2px 8px rgba(218, 110, 11, 0.3)',
        transition: 'all 0.2s ease',
    };

    const addIconStyle = {
        width: '44px',
        height: '44px',
        minWidth: '44px',
        display: 'flex',
        padding: '0',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        border: '2px solid #da6e0b',
        color: '#da6e0b',
        backgroundColor: 'transparent',
        transition: 'all 0.2s ease',
    };

    useEffect(() => {
        if (lastJsonMessage) {

            console.log("Last JSON Message:", lastJsonMessage);

            const { event, action, from, type, participants } = lastJsonMessage;

            if (from === patient_id) {
                if (event === "typing") {
                    setIsPatientTyping(true);
                } else if (event === "stopTyping") {
                    setIsPatientTyping(false);
                } else if (action === "Typing") {
                    setIsPatientTyping(true);
                } else if (action === "StopTyping" || action === "stopTyping") {
                    setIsPatientTyping(false);
                } else if (action === "userStatus") {
                    if (lastJsonMessage.status === "online") {
                        setOnline(prev => [...prev.filter(u => u.userId !== from), { userId: from }]);
                    } else if (lastJsonMessage.status === "offline") {
                        setOnline(prev => prev.filter(u => u.userId !== from));
                        setLastSeen(prev => [...prev.filter(u => u.userId !== from), { userId: from, time: lastJsonMessage.lastSeen || new Date().toISOString() }]);
                    }
                }
            }

            if (type === 'presence_snapshot' && Array.isArray(participants)) {
                console.log("Presence Snapshot:", participants);

                const onlineUsers = participants
                    .filter(p => p.status === 'online')
                    .map(p => ({ userId: p.userId }));
                setOnline(onlineUsers);


                const offlineUsers = participants
                    .filter(p => p.status === 'offline' && p.lastSeen)
                    .map(p => ({
                        userId: p.userId,
                        time: typeof p.lastSeen === 'number' ? new Date(p.lastSeen * 1000).toISOString() : p.lastSeen
                    }));

                if (offlineUsers.length > 0) {
                    setLastSeen(prev => {
                        const newLastSeen = [...prev];
                        offlineUsers.forEach(offlineUser => {
                            const index = newLastSeen.findIndex(u => u.userId === offlineUser.userId);
                            if (index !== -1) {
                                newLastSeen[index] = offlineUser;
                            } else {
                                newLastSeen.push(offlineUser);
                            }
                        });
                        return newLastSeen;
                    });
                }
            }

            if (action === "onlineUsers" && Array.isArray(lastJsonMessage.users)) {
                setOnline(lastJsonMessage.users.map(id => ({ userId: id })));
            }

            if (action === "sendMessage" || lastJsonMessage.type === "text") {
                setIsPatientTyping(false);
                if (!online.find(u => u.userId === from)) {
                    setOnline(prev => [...prev.filter(u => u.userId !== from), { userId: from }]);
                }
            }
        }
    }, [lastJsonMessage, currentChat, patient_id]);

    const handleTyping = () => {

        sendJsonMessage({
            action: "Typing",
            from: doctor_id,
            to: patient_id,
            event: "typing"
        });

        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

        typingTimeoutRef.current = setTimeout(() => {
            sendJsonMessage({
                action: "Typing",
                from: doctor_id,
                to: patient_id,
                event: "stopTyping"
            });
        }, 2000);
    };

    const handleMediaClick = (message, type, e) => {
        // Don't open dialog if clicking on audio controls
        if (e && (e.target.closest('.MuiIconButton-root') || e.target.closest('button'))) {
            return;
        }

        let formattedDate = 'Unknown';
        if (message.timestamp) {
            const date = new Date(message.timestamp);
            formattedDate = date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        }

        setMediaDialog({
            open: true,
            media: message.message,
            type: type,
            date: formattedDate
        });
    };

    const handleCloseMediaDialog = () => {
        setMediaDialog({ open: false, media: null, type: null, date: null });
    };

    const handleDownloadMedia = () => {
        const link = document.createElement('a');
        link.href = mediaDialog.media;
        let extension = 'file';
        if (mediaDialog.type === 'image') extension = 'jpg';
        else if (mediaDialog.type === 'video') extension = 'mp4';
        else if (mediaDialog.type === 'audio') extension = 'mp3';
        else if (mediaDialog.type === 'document') extension = 'pdf';

        link.download = `media_${Date.now()}.${extension}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleShareMedia = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Share Media',
                    text: 'Check out this media',
                    url: mediaDialog.media
                });
            } catch (error) {
                console.log('Error sharing:', error);
            }
        } else {
            // Fallback: copy to clipboard
            navigator.clipboard.writeText(mediaDialog.media);
            alert('Link copied to clipboard!');
        }
    };

    // Audio Recording Functions
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;
            audioChunksRef.current = [];

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    audioChunksRef.current.push(event.data);
                }
            };

            mediaRecorder.start();
            setIsRecording(true);
            setShowRecordingModal(true);
            setRecordingTime(0);

            recordingIntervalRef.current = setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000);
        } catch (error) {
            console.error('Error accessing microphone:', error);
            alert('Could not access microphone. Please check permissions.');
        }
    };

    const pauseRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
            mediaRecorderRef.current.pause();
            setIsPaused(true);
            clearInterval(recordingIntervalRef.current);
        }
    };

    const resumeRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'paused') {
            mediaRecorderRef.current.resume();
            setIsPaused(false);
            recordingIntervalRef.current = setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000);
        }
    };

    const stopRecording = async () => {
        return new Promise((resolve) => {
            if (mediaRecorderRef.current) {
                mediaRecorderRef.current.onstop = async () => {
                    const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });

                    // Convert to base64
                    const reader = new FileReader();
                    reader.readAsDataURL(audioBlob);
                    reader.onloadend = async () => {
                        const base64Audio = reader.result.split(',')[1];

                        try {
                            const response = await teleConsultationModel.post('UploadChatAudio', {
                                audio: base64Audio,
                                appointment_ID: currentChat.Appointment_id
                            });

                            if (response.data && response.data.data) {
                                // Send audio message via WebSocket
                                sendJsonMessage({
                                    action: "sendMessage",
                                    message: response.data.data,
                                    type: "audio",
                                    from: doctor_id,
                                    to: patient_id,
                                    conversationId: `${currentChat?.Appointment_id}`,
                                });

                                // senChatNotification(doctor_id, patient_id, "audio", response.data.data);
                            }
                        } catch (error) {
                            console.error('Error uploading audio:', error);
                            alert('Failed to upload audio. Please try again.');
                        }

                        resolve();
                    };
                };

                mediaRecorderRef.current.stop();
                mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
                clearInterval(recordingIntervalRef.current);
                setIsRecording(false);
                setIsPaused(false);
                setShowRecordingModal(false);
                setRecordingTime(0);
            }
        });
    };

    const getChatUser = async () => {
        try {
            const response = await teleConsultationModel.post('getChatUser', {
                appointmentId: Appointment_id
            });
            if (response.status === 200) {
                const { type, participants } = response.data;

                if (type === 'presence_snapshot' && Array.isArray(participants)) {
                    console.log("Presence Snapshot:", participants);

                    const onlineUsers = participants
                        .filter(p => p.status === 'online')
                        .map(p => ({ userId: p.userId }));
                    setOnline(onlineUsers);


                    const offlineUsers = participants
                        .filter(p => p.status === 'offline' && p.lastSeen)
                        .map(p => ({
                            userId: p.userId,
                            time: typeof p.lastSeen === 'number' ? new Date(p.lastSeen * 1000).toISOString() : p.lastSeen
                        }));

                    if (offlineUsers.length > 0) {
                        setLastSeen(prev => {
                            const newLastSeen = [...prev];
                            offlineUsers.forEach(offlineUser => {
                                const index = newLastSeen.findIndex(u => u.userId === offlineUser.userId);
                                if (index !== -1) {
                                    newLastSeen[index] = offlineUser;
                                } else {
                                    newLastSeen.push(offlineUser);
                                }
                            });
                            return newLastSeen;
                        });
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching chat user:', error);
        }
    }

    const cancelRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
            clearInterval(recordingIntervalRef.current);
            audioChunksRef.current = [];
            setIsRecording(false);
            setIsPaused(false);
            setShowRecordingModal(false);
            setRecordingTime(0);
        }
    };

    const renderMessageContent = (text) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const urls = text.match(urlRegex);

        if (!urls) return text;

        const parts = text.split(urlRegex);

        return (
            <>
                <div>
                    {parts.map((part, i) => (
                        urlRegex.test(part) ?
                            <a key={i} href={part} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>{part}</a> :
                            part
                    ))}
                </div>
                {urls.map((url, index) => (
                    <LinkPreviewCard key={index} url={url} />
                ))}
            </>
        );
    };

    const sendChat = () => {

        if (msg.trim() === '') return;

        sendJsonMessage({
            action: "sendMessage",
            message: msg,
            type: "text",
            from: doctor_id,
            to: patient_id,
            conversationId: `${currentChat?.Appointment_id}`,
        });

        // senChatNotification(doctor_id, patient_id, "text", msg);

        setmsg('');
    };

    let Collectmsgs = async () => {
        try {
            const res = await teleConsultationModel.post('getMessages', {
                conversationId: currentChat?.Appointment_id
            });

            if (res.status === 200) {
                setmessages(res.data);
            }

        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        Collectmsgs()
    }, [lastJsonMessage, currentChat]);

    const resizeTextArea = () => {
        if (textAreaRef.current) {
            textAreaRef.current.style.height = "auto";
            const scrollHeight = textAreaRef.current.scrollHeight;
            const maxHeight = 100; // Approximately 4 lines
            textAreaRef.current.style.height = Math.min(scrollHeight, maxHeight) + "px";
        }
    };

    useEffect(
        resizeTextArea,
        [msg]);


    useEffect(() => {
        arrivalMessage && setmessages((prev) => [...prev, arrivalMessage]);
    }, [arrivalMessage]);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, lastJsonMessage]);

    return <div className='chat-box border-[1px] border-neutral-300'>
        <div className='chat-head' style={{
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(10px)',
            padding: '16px 24px',
            borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
        }}>
            {fromProfile && (
                <IconButton
                    onClick={() => {
                        if ((currentChat?.patient_id || currentChat?._id)) {
                            const appointmentId = currentChat.Appointment_id;
                            navigate(`/Patient/${appointmentId}`);
                        }
                    }}
                    sx={{
                        marginRight: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(218, 110, 11, 0.08)',
                        }
                    }}
                >
                    <ArrowBack sx={{ color: '#da6e0b' }} />
                </IconButton>
            )}

            <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                onClick={() => {
                    if (!fromProfile && (currentChat?.patient_id || currentChat?._id)) {
                        const appointmentId = currentChat.Appointment_id;
                        navigate(`/Patient/${appointmentId}`);
                    }
                }}
                sx={{
                    cursor: !fromProfile ? 'pointer' : 'default',
                    flex: 1,
                    '&:hover': !fromProfile ? { opacity: 0.85 } : {},
                    transition: 'opacity 0.2s ease'
                }}
            >
                <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    variant={online.find((u) => u?.userId === currentChat?._id || u?.userId === currentChat?.patient_id) ? "dot" : "standard"}
                >
                    <Avatar
                        alt={currentChat?.patient_name}
                        src={currentChat?.avatar}
                        sx={{ width: 44, height: 44, border: '2px solid #fff', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                    >
                        {/* {!currentChat?.avatar && <AccountCircle sx={{ width: 44, height: 44, color: '#bdbdbd' }} />} */}
                    </Avatar>
                </StyledBadge>
                <div className='flex flex-col'>
                    <Typography variant="subtitle1" sx={{ fontWeight: '600', color: '#333', lineHeight: 1.2 }}>
                        {currentChat?.patient_name}
                    </Typography>
                    <div className='typing-text' style={{ fontSize: '12px' }}>
                        {
                            isPatientTyping ?
                                <p style={{ color: '#4CAF50', fontStyle: 'italic', margin: 0 }}>typing...</p> :
                                online.find((u) => u?.userId === currentChat?._id || u?.userId === currentChat?.patient_id) ?
                                    <p style={{ color: '#4CAF50', margin: 0, fontWeight: '500' }}>Online</p> :
                                    (() => {
                                        const userLastSeen = lastseen.find((u) => u?.userId === currentChat?._id || u?.userId === currentChat?.patient_id);
                                        if (userLastSeen && userLastSeen.time) {
                                            const date = new Date(userLastSeen.time);
                                            const now = new Date();
                                            const diff = now - date;
                                            const mins = Math.floor(diff / 60000);
                                            const hours = Math.floor(mins / 60);
                                            const days = Math.floor(hours / 24);

                                            let timeStr = "";
                                            if (days > 0) timeStr = `${days}d ago`;
                                            else if (hours > 0) timeStr = `${hours}h ago`;
                                            else if (mins > 0) timeStr = `${mins}m ago`;
                                            else timeStr = "just now";

                                            return <p style={{ color: '#757575', margin: 0 }}>Last seen {timeStr}</p>;
                                        }
                                        return <p style={{ color: '#757575', margin: 0 }}>Offline</p>;
                                    })()
                        }
                    </div>
                </div>
            </Stack>
        </div>
        <div className='chat-body ' ref={scrollRef}>
            {
                messages.map((e, i) => {
                    return <div
                        key={i}
                        className={e?.from === doctor_id ? "message own" : "message"}
                    >
                        <span>{e.type === "image" ?
                            <img
                                src={e.message}
                                onClick={(event) => handleMediaClick(e, 'image', event)}
                                style={{ cursor: 'pointer', maxWidth: '100%', borderRadius: '8px' }}
                                alt="chat media"
                            /> :
                            e.type === "video" ?
                                <div onClick={(event) => handleMediaClick(e, 'video', event)} style={{ cursor: 'pointer', position: 'relative' }}>
                                    <video src={e.message} style={{ maxWidth: '100%', borderRadius: '8px' }} />
                                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'rgba(0,0,0,0.5)', borderRadius: '50%', padding: '8px' }}>
                                        <PlayArrow style={{ color: 'white' }} />
                                    </div>
                                </div> :
                                e.type === "audio" ?
                                    <div onClick={(event) => handleMediaClick(e, 'audio', event)} style={{ cursor: 'pointer' }}>
                                        <AudioWave audioUrl={e.message} />
                                    </div> :
                                    e.type === "document" ?
                                        <div onClick={(event) => handleMediaClick(e, 'document', event)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', padding: '10px', backgroundColor: 'rgba(59, 54, 42, 0.05)', borderRadius: '8px' }}>
                                            <InsertDriveFile style={{ color: '#da6e0b' }} />
                                            <span style={{ fontSize: '14px', wordBreak: 'break-all' }}>{e.filename || "Document"}</span>
                                        </div> :
                                        renderMessageContent(e.message)
                        }
                        </span>
                    </div>
                })

            }

            {
                isPatientTyping &&
                <div className='typinganimation-container'>
                    <Lottie animationData={typinganimation} loop={true}></Lottie>
                </div>
            }



            <div ref={messagesEndRef} />
        </div>
        <div className='chat-footer'>
            {isUploading && (
                <Box sx={{ width: '100%', padding: '0 10px 10px 10px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '12px', fontWeight: '500', color: '#da6e0b' }}>
                            Uploading...
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '12px', fontWeight: '500' }}>
                            {uploadProgress}%
                        </Typography>
                    </Box>
                    <LinearProgress
                        variant="determinate"
                        value={uploadProgress}
                        sx={{
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: 'rgba(218, 110, 11, 0.1)',
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: '#da6e0b',
                                borderRadius: 3,
                            }
                        }}
                    />
                </Box>
            )}
            <div className='chat-footer-action-inputs flex flex-row'>
                <div className='chat-footer-textarea'>
                    <textarea ref={textAreaRef} placeholder="Message..." value={msg} style={{ color: "black" }}
                        type='text' onChange={(e) => {
                            setmsg(e.target.value);
                            handleTyping();
                        }} row="1" />
                </div>

                <div className='chat-icons'>
                    <Button style={addIconStyle} onClick={handleOpen}>
                        <AddIcon />
                    </Button>

                    {/* Mic button for audio recording */}
                    <IconButton
                        onClick={startRecording}
                        disabled={isRecording}
                        style={{
                            width: '44px',
                            height: '44px',
                            color: isRecording ? '#999' : '#da6e0b',
                            border: `2px solid ${isRecording ? '#999' : '#da6e0b'}`,
                            backgroundColor: 'transparent',
                        }}
                    >
                        <Mic />
                    </IconButton>

                    {/* Hidden file input */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                    />

                    {/* Dialog Box */}
                    <Dialog open={open} onClose={handleClose}>
                        <DialogTitle style={{ textAlign: 'center', fontFamily: 'Poppins, sans-serif', fontWeight: '600' }}>Select Media</DialogTitle>
                        <DialogActions
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                gap: '16px',
                                padding: '24px',
                            }}
                        >
                            <Button
                                onClick={() => handleFileSelection("image")}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '12px',
                                    color: '#E91E63',
                                    textTransform: 'none'
                                }}
                            >
                                <Image style={{ fontSize: '32px' }} />
                                <span style={{ fontSize: '12px', fontWeight: '500' }}>Image</span>
                            </Button>
                            <Button
                                onClick={() => handleFileSelection("video")}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '12px',
                                    color: '#2196F3',
                                    textTransform: 'none'
                                }}
                            >
                                <Videocam style={{ fontSize: '32px' }} />
                                <span style={{ fontSize: '12px', fontWeight: '500' }}>Video</span>
                            </Button>
                            <Button
                                onClick={() => handleFileSelection("document")}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '12px',
                                    color: '#4CAF50',
                                    textTransform: 'none'
                                }}
                            >
                                <InsertDriveFile style={{ fontSize: '32px' }} />
                                <span style={{ fontSize: '12px', fontWeight: '500' }}>Document</span>
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {msg.length > 1 && (
                        <Button style={sendIconStyle} onClick={sendChat}>
                            <SendIcon style={{ color: "#da6e0v" }} fontSize='small' />
                        </Button>
                    )}
                </div>

            </div>

        </div>

        {/* Media Preview Dialog */}
        <Dialog
            open={mediaDialog.open}
            onClose={handleCloseMediaDialog}
            maxWidth="md"
            fullWidth
            PaperProps={{
                style: {
                    backgroundColor: 'rgba(231, 231, 219, 0.98)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                    borderRadius: '12px',
                }
            }}
            BackdropProps={{
                style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                }
            }}
        >
            <div style={{
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                position: 'relative'
            }}>
                {/* Close Button */}
                <IconButton
                    onClick={handleCloseMediaDialog}
                    style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        color: '#3b362a',
                        backgroundColor: 'rgba(59, 54, 42, 0.1)',
                    }}
                >
                    <Close />
                </IconButton>

                {/* Media Content */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '300px',
                    marginTop: '20px'
                }}>
                    {mediaDialog.type === 'image' ? (
                        <img
                            src={mediaDialog.media}
                            alt="preview"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '500px',
                                borderRadius: '8px',
                                objectFit: 'contain'
                            }}
                        />
                    ) : mediaDialog.type === 'video' ? (
                        <video
                            src={mediaDialog.media}
                            controls
                            autoPlay
                            style={{
                                maxWidth: '100%',
                                maxHeight: '500px',
                                borderRadius: '8px'
                            }}
                        />
                    ) : mediaDialog.type === 'audio' ? (
                        <div style={{ width: '100%' }}>
                            <AudioWave audioUrl={mediaDialog.media} />
                        </div>
                    ) : mediaDialog.type === 'document' ? (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '20px',
                            padding: '40px'
                        }}>
                            <InsertDriveFile style={{ fontSize: '100px', color: '#da6e0b' }} />
                            <div style={{ fontFamily: 'Poppins, sans-serif', fontWeight: '500', color: '#3b362a' }}>
                                Document Preview Not Available
                            </div>
                        </div>
                    ) : null}
                </div>

                {/* Date */}
                <div style={{
                    textAlign: 'center',
                    color: '#75623f',
                    fontSize: '14px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '500'
                }}>
                    Sent: {mediaDialog.date}
                </div>

                {/* Action Buttons */}
                <div style={{
                    display: 'flex',
                    gap: '12px',
                    justifyContent: 'center',
                    marginTop: '8px'
                }}>
                    <Button
                        variant="contained"
                        startIcon={<Share />}
                        onClick={handleShareMedia}
                        style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            textTransform: 'none',
                            padding: '10px 24px',
                            borderRadius: '8px',
                            fontFamily: 'Poppins, sans-serif'
                        }}
                    >
                        Share
                    </Button>
                    <Button
                        variant="contained"
                        startIcon={<Download />}
                        onClick={handleDownloadMedia}
                        style={{
                            backgroundColor: '#2196F3',
                            color: 'white',
                            textTransform: 'none',
                            padding: '10px 24px',
                            borderRadius: '8px',
                            fontFamily: 'Poppins, sans-serif'
                        }}
                    >
                        Download
                    </Button>
                </div>
            </div>
        </Dialog>

        {/* Recording Modal */}
        <Dialog
            open={showRecordingModal}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: {
                    backgroundColor: 'rgba(231, 231, 219, 0.98)',
                    borderRadius: '12px',
                }
            }}
        >
            <div style={{ padding: '24px', textAlign: 'center' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '20px'
                }}>
                    {/* Recording Icon */}
                    <div style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        backgroundColor: isPaused ? '#ff9800' : '#f44336',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: !isPaused ? 'pulse 1.5s infinite' : 'none',
                    }}>
                        <Mic style={{ color: 'white', fontSize: '40px' }} />
                    </div>

                    {/* Status Text */}
                    <div style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '18px',
                        fontWeight: '600',
                        color: '#3b362a'
                    }}>
                        {isPaused ? 'Recording Paused' : 'Recording...'}
                    </div>

                    {/* Timer */}
                    <div style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '32px',
                        fontWeight: '700',
                        color: '#da6e0b',
                        minWidth: '120px'
                    }}>
                        {formatTime(recordingTime)}
                    </div>

                    {/* Control Buttons */}
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        marginTop: '12px'
                    }}>
                        {isRecording && !isPaused && (
                            <Button
                                variant="contained"
                                startIcon={<Pause />}
                                onClick={pauseRecording}
                                style={{
                                    backgroundColor: '#ff9800',
                                    color: 'white',
                                    textTransform: 'none',
                                    padding: '10px 20px',
                                }}
                            >
                                Pause
                            </Button>
                        )}

                        {isRecording && isPaused && (
                            <Button
                                variant="contained"
                                startIcon={<PlayArrow />}
                                onClick={resumeRecording}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    textTransform: 'none',
                                    padding: '10px 20px',
                                }}
                            >
                                Resume
                            </Button>
                        )}

                        <Button
                            variant="contained"
                            startIcon={<Stop />}
                            onClick={stopRecording}
                            style={{
                                backgroundColor: '#da6e0b',
                                color: 'white',
                                textTransform: 'none',
                                padding: '10px 20px',
                            }}
                        >
                            Stop & Send
                        </Button>

                        <Button
                            variant="outlined"
                            startIcon={<Close />}
                            onClick={cancelRecording}
                            style={{
                                borderColor: '#f44336',
                                color: '#f44336',
                                textTransform: 'none',
                                padding: '10px 20px',
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>







}

export default Chat